var _path, _circle, _circle2, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 90,
    viewBox: "0 0 32 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 90C20.4183 90 24 86.4183 24 82C24 77.5817 20.4183 74 16 74C11.5817 74 8 77.5817 8 82C8 86.4183 11.5817 90 16 90ZM16 25C20.4183 25 24 21.4183 24 17C24 12.5817 20.4183 9 16 9C11.5817 9 8 12.5817 8 17C8 21.4183 11.5817 25 16 25ZM17.5 82L17.5 17L14.5 17L14.5 82L17.5 82Z",
    fill: "#8DF6F5"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#8DF6F5"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 16.5,
    r: 11,
    stroke: "#475F5E",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.626 19.5276V18.6736C12.626 18.319 12.71 18.0016 12.878 17.7216C13.046 17.4416 13.27 17.2176 13.55 17.0496C13.8393 16.8816 14.152 16.7976 14.488 16.7976H17.988C18.0533 16.7976 18.1093 16.7743 18.156 16.7276C18.212 16.6716 18.24 16.611 18.24 16.5456V14.1516C18.24 14.077 18.212 14.0163 18.156 13.9696C18.1093 13.9136 18.0533 13.8856 17.988 13.8856H11.1V12.2056H18.03C18.3753 12.2056 18.688 12.2943 18.968 12.4716C19.2573 12.6396 19.486 12.8636 19.654 13.1436C19.8313 13.4236 19.92 13.741 19.92 14.0956V16.6016C19.92 16.9376 19.8313 17.2503 19.654 17.5396C19.486 17.8196 19.2573 18.0483 18.968 18.2256C18.688 18.3936 18.3753 18.4776 18.03 18.4776H14.558C14.4927 18.4776 14.432 18.5056 14.376 18.5616C14.3293 18.6083 14.306 18.6643 14.306 18.7296V19.5276H12.626ZM12.626 22.2856V20.6196H14.306V22.2856H12.626Z",
    fill: "#475F5E"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTip);
export default __webpack_public_path__ + "static/media/tip.a21de8bf29846d156be28427ffb8a22f.svg";
export { ForwardRef as ReactComponent };